import React from 'react';
import { CheckButton } from '@apply/components';
import { isMobileScreen } from '@apply/ui';

interface BackgroundCheckFieldProps {
    showBackgroundCheckDate: boolean;
    onToggle: (value: boolean) => void;
}

export const BackgroundCheckField: React.FC<BackgroundCheckFieldProps> = ({ showBackgroundCheckDate, onToggle }) => {
    const mobileScreen = isMobileScreen();
    return (
        <CheckButton
            id='backgroundCheckBox'
            selected={showBackgroundCheckDate}
            onToggle={() => onToggle(!showBackgroundCheckDate)}
            label='Clean background'
            width={!mobileScreen ? '200px' : '100%'}
        />
    );
};
